import _extends from "@babel/runtime/helpers/extends";
import { createStyles, makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    root: {
      width: function width(props) {
        return typeof (props == null ? void 0 : props.size) === 'number' ? props == null ? void 0 : props.size : undefined;
      },
      height: function height(props) {
        return typeof (props == null ? void 0 : props.size) === 'number' ? props == null ? void 0 : props.size : undefined;
      }
    },
    tiny: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      fontSize: 12,
      '& .MuiSvgIcon-root': {
        width: theme.spacing(1),
        height: theme.spacing(1)
      }
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      fontSize: 18,
      '& .MuiSvgIcon-root': {
        width: theme.spacing(2),
        height: theme.spacing(2)
      }
    },
    normal: {
      fontSize: 25
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
      fontSize: 40,
      '& .MuiSvgIcon-root': {
        width: theme.spacing(6),
        height: theme.spacing(6)
      }
    },
    shadow: {
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px'
    },
    cursor: {
      cursor: 'pointer'
    },
    shadowBadge: {
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px'
    },
    border: function border(props) {
      return _extends({
        border: "2px solid " + theme.palette.background.paper
      }, props == null ? void 0 : props.borderStyle);
    }
  });
});
export default useStyles;